import { gql } from '@apollo/client'

export function FETCH_RISK_REPORT() {
  return gql`
    query GET_RISK_REPORT(
      $clientId: String!
      $insuranceType: String
      $subInsuranceType: String
    ) {
      getRiskReport(
        riskReportType: CATEGORICAL
        clientId: $clientId
        clientType: CORPORATE
        insuranceType: $insuranceType
        subInsuranceType: $subInsuranceType
        isFinancialYearClaimsType: true
      ) {
        policyTemplate {
          id
          insuranceType
          features
          keyPoints {
            name
            keyPointDetails {
              heading {
                fieldType
                fieldName
                fieldValue
                valuesAllowed
              }
              subHeadings {
                fieldType
                fieldName
                fieldValue
                valuesAllowed
              }
            }
          }
        }
        riskReportAvailable
        policyInsuranceTypeAggregate {
          insuranceType
          premium
          sumAssured
          claimAmount
          vehicleIdv
        }
        riskInsurance {
          userDetails {
            userName
            industryType
            companySize
            updatedOn
            riskCreatedOn
            riskReportStatus
            rarScore
          }
          clientId
          riskList
          riskData {
            keyPoints {
              name
              keyPointDetails {
                heading {
                  fieldType
                  fieldName
                  fieldValue
                  valuesAllowed
                }
                subHeadings {
                  fieldType
                  fieldName
                  fieldValue
                  valuesAllowed
                }
              }
            }
            fireKeyDetails {
              sumInsured
              premiumPaid
              locationsCovered
              basisOfCoverage
              stocksWarehouses
              stocksCoverage
            }
            marineKeyDetails {
              domesticTurnOver
              portTurnover
              totalTurnover
              premium
              typeOfPolicy
              coverage
            }
            groupHealthKeyDetails {
              sumInsuredRange
              premiumPaid
              permanentEmployees
              contactEmployees
              totalEmployees
              employeesCovered
              avgFamilySize
              familyDefinition
              numberOfLives
            }
            keySuggestions
            ageDistribution {
              group
              value
            }
            addonCoverageData {
              coverage
              value
            }
            subTypeCounts {
              subType
              count
            }
            insuranceSubTypeStats {
              insuranceSubType
              count
            }
            groupedReports {
              riskReport {
                name
                originalName
                category
                size
                storage
                type
                url
                data {
                  baseUrl
                  form
                  id
                  project
                  version
                }
              }
              quotes {
                name
                originalName
                category
                size
                storage
                type
                url
                data {
                  baseUrl
                  form
                  id
                  project
                  version
                }
              }
              rfq {
                name
                originalName
                category
                size
                storage
                type
                url
                data {
                  baseUrl
                  form
                  id
                  project
                  version
                }
              }
              others {
                name
                originalName
                category
                size
                storage
                type
                url
                data {
                  baseUrl
                  form
                  id
                  project
                  version
                }
              }
            }
            claimStatusCounts {
              claimStatus
              count
            }
            financialYearClaimStatusCounts {
              claimStatus
              count
            }
            financialYearlyClaimData {
              turnOver
              totalPremium
              totalClaims
              claimsPaid
              claimsOutstanding
              year
              claimsRatio
            }
            reportUrls
            reports {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            premiumClaimYearlyData {
              turnOver
              totalPremium
              totalClaims
              claimsPaid
              claimsOutstanding
              year
              claimsRatio
            }
            claimConsumptionCounts {
              identity
              numberOfClaims
              totalClaimAmount
            }
            topRisks {
              insuranceType
              imageUrl
              risk
            }
            healthPortfolioAnalysis {
              year
              numberOfEmployees
              numberOfLives
              parentsIncluded
              premiumPaid
              claimSettled
              claimsOutstanding
              claimsRatio
            }
            claimsTypeData {
              employeeBenefits {
                policyName
                employeeName
                claimAmount
                pendingSince
                remarks
                claimType
                employeeId
                employeeName
                claimantName
                relation
                dateOfBirth
                claimantAge
                gender
                dateOfAdmission
                dateOfDischarge
                ailment
                amountClaimed
                finalApprovedAmount
                claimStatus
                pendingFrom
                policyNumber
              }
              nonEmployeeBenefits {
                policyName
                estClaimAmount
                remarks
                dateOfLoss
                claimStatus
                natureOfLoss
                insuranceCompanyName
                policyNumber
                settledClaimAmount
                outstandingClaimAmount
              }
            }
            claimStatusUpdatedOn
            financialYearClaimsData {
              employeeBenefits {
                policyName
                employeeName
                claimAmount
                pendingSince
                remarks
              }
              nonEmployeeBenefits {
                policyName
                policyNumber
                dateOfLoss
                natureOfLoss
                settledClaimAmount
                outstandingClaimAmount
              }
            }
            financialYearClaimStatusUpdatedOn
          }
          policies {
            sysAnnexureDocumentURL
            otherInformation {
              vehicleIdv
            }
            sysAnnexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageDocumentURL
            coverageDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageTypes
            fileName
            policyDocumentURL
            policyDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            annexureDocumentURL
            annexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            id
            status
            clientId
            policyHolder {
              type
            }
            issuedOn
            expiresOn
            premiumAmount {
              text
            }
            claimAmount {
              text
            }
            productImage
            sumAssured {
              text
            }
            coverageUpto {
              text
            }
            provider {
              id
              name
              image
            }
            type
            insuranceType
            productSubType
          }
          aggregatedPolicies {
            activePolicies {
              insuranceType
              policies {
                otherInformation {
                  vehicleIdv
                }
                sysAnnexureDocumentURL
                sysAnnexureDocument {
                  name
                  originalName
                  size
                  storage
                  type
                  url
                  data {
                    id
                    baseUrl
                    form
                    project
                    version
                  }
                }
                coverageDocumentURL
                coverageDocument {
                  name
                  originalName
                  size
                  storage
                  type
                  url
                  data {
                    id
                    baseUrl
                    form
                    project
                    version
                  }
                }
                coverageTypes
                fileName
                policyDocumentURL
                policyDocument {
                  name
                  originalName
                  size
                  storage
                  type
                  url
                  data {
                    id
                    baseUrl
                    form
                    project
                    version
                  }
                }
                annexureDocumentURL
                annexureDocument {
                  name
                  originalName
                  size
                  storage
                  type
                  url
                  data {
                    id
                    baseUrl
                    form
                    project
                    version
                  }
                }
                id
                status
                clientId
                policyHolder {
                  type
                }
                issuedOn
                expiresOn
                premiumAmount {
                  text
                }
                approximatedPremiumAmount {
                  text
                }
                claimAmount {
                  text
                }
                productImage
                sumAssured {
                  text
                }
                coverageUpto {
                  text
                }
                provider {
                  id
                  name
                  image
                }
                type
                insuranceType
                productSubType
              }
            }
            nearToExpirePolicies {
              insuranceType
              policies {
                otherInformation {
                  vehicleIdv
                }
                sysAnnexureDocumentURL
                sysAnnexureDocument {
                  name
                  originalName
                  size
                  storage
                  type
                  url
                  data {
                    id
                    baseUrl
                    form
                    project
                    version
                  }
                }
                coverageDocumentURL
                coverageDocument {
                  name
                  originalName
                  size
                  storage
                  type
                  url
                  data {
                    id
                    baseUrl
                    form
                    project
                    version
                  }
                }
                coverageTypes
                fileName
                policyDocumentURL
                policyDocument {
                  name
                  originalName
                  size
                  storage
                  type
                  url
                  data {
                    id
                    baseUrl
                    form
                    project
                    version
                  }
                }
                annexureDocumentURL
                annexureDocument {
                  name
                  originalName
                  size
                  storage
                  type
                  url
                  data {
                    id
                    baseUrl
                    form
                    project
                    version
                  }
                }
                id
                status
                clientId
                policyHolder {
                  type
                }
                issuedOn
                expiresOn
                premiumAmount {
                  text
                }
                approximatedPremiumAmount {
                  text
                }
                claimAmount {
                  text
                }
                productImage
                sumAssured {
                  text
                }
                coverageUpto {
                  text
                }
                provider {
                  id
                  name
                  image
                }
                type
                insuranceType
                productSubType
              }
            }
            expiredPolicies {
              insuranceType
              policies {
                otherInformation {
                  vehicleIdv
                }
                sysAnnexureDocumentURL
                sysAnnexureDocument {
                  name
                  originalName
                  size
                  storage
                  type
                  url
                  data {
                    id
                    baseUrl
                    form
                    project
                    version
                  }
                }
                coverageDocumentURL
                coverageDocument {
                  name
                  originalName
                  size
                  storage
                  type
                  url
                  data {
                    id
                    baseUrl
                    form
                    project
                    version
                  }
                }
                coverageTypes
                fileName
                policyDocumentURL
                policyDocument {
                  name
                  originalName
                  size
                  storage
                  type
                  url
                  data {
                    id
                    baseUrl
                    form
                    project
                    version
                  }
                }
                annexureDocumentURL
                annexureDocument {
                  name
                  originalName
                  size
                  storage
                  type
                  url
                  data {
                    id
                    baseUrl
                    form
                    project
                    version
                  }
                }
                id
                status
                clientId
                policyHolder {
                  type
                }
                issuedOn
                expiresOn
                premiumAmount {
                  text
                }
                approximatedPremiumAmount {
                  text
                }
                claimAmount {
                  text
                }
                productImage
                sumAssured {
                  text
                }
                coverageUpto {
                  text
                }
                provider {
                  id
                  name
                  image
                }
                type
                insuranceType
                productSubType
              }
            }
          }
        }
      }
    }
  `
}
